import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../src/style/index.less'
Vue.config.productionTip = false
import messageBox from '@/components/Message/index'
Vue.use(messageBox)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
